import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./datenschutz.css"; // Falls du zusätzliches Styling brauchst

const Datenschutz = () => {
  return (
    <div className="container">
      <div className="datenschutz-container">
        <h1>Datenschutzerklärung</h1>

        <h2>1. Verantwortlicher</h2>
        <p>
          <strong>Pohlert Steinreinigung</strong><br />
          Marvin Simon Pohlert<br />
          Weideweg 5 (OT Wallengrün)<br />
          07952 Pause-Mültroff<br />
          Tel: <a href="tel:+015754929865">+49 1575 49 29 865</a><br />
          E-Mail: <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a>
        </p>

        <h2>2. Allgemeine Hinweise</h2>
        <p>
          Wir nehmen den Schutz deiner persönlichen Daten ernst. Die Verarbeitung personenbezogener Daten erfolgt gemäß der{" "}
          <strong>Datenschutz-Grundverordnung (DSGVO)</strong> und dem <strong>Bundesdatenschutzgesetz (BDSG).</strong>
        </p>

        <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
        <h3>a) Beim Besuch der Website</h3>
        <p>Beim Zugriff auf unsere Website werden automatisch folgende Daten erfasst:</p>
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Browsertyp und -version</li>
          <li>Betriebssystem</li>
          <li>Referrer-URL</li>
        </ul>
        <p>Diese Daten sind technisch notwendig und dienen ausschließlich der Sicherheit und Optimierung der Website.</p>

        <h3>b) Kontaktaufnahme</h3>
        <p>
          Bei einer Kontaktaufnahme per E-Mail oder Telefon speichern wir die von dir angegebenen Daten (z. B. Name, Telefonnummer,
          E-Mail-Adresse), um deine Anfrage zu bearbeiten.
        </p>

        <h2>4. Keine Verwendung von Cookies</h2>
        <p>Unsere Website setzt <strong>keine Cookies</strong> ein.</p>

        <h2>5. Hosting & Server-Logfiles</h2>
        <p>Unsere Website wird bei <strong>Strato</strong> gehostet. Dabei werden Server-Logfiles erstellt, die aus Sicherheitsgründen gespeichert werden.</p>

        <h2>6. Rechte der betroffenen Personen</h2>
        <p>Du hast folgende Rechte:</p>
        <ul>
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        </ul>
        <p>
          Anfragen hierzu kannst du an <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a> senden.
        </p>

        <h2>7. Änderungen dieser Datenschutzerklärung</h2>
        <p>Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren. Die jeweils aktuelle Version ist jederzeit auf unserer Website einsehbar.</p>

        <p>
          <strong>Letzte Aktualisierung:</strong> März 2025
        </p>

        <p>
          Fragen? Schreib uns an:{" "}
          <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default Datenschutz;
